import type { Questionnaire } from '@medplum/fhirtypes'

export const EmergencyContactAndDecisionsQuestionnaire = {
  resourceType: 'Questionnaire',
  url: 'https://www.seenhealth.org/fhir/Questionnaire/demographics-contact',
  status: 'draft',
  subjectType: ['Patient'],
  name: 'Emergency Contact & Decisions Demographics',
  title: 'Emergency Contact & Decisions',
  item: [
    {
      linkId: 'emergency-response',
      text: 'Emergency Response',
      type: 'text',
    },
    {
      linkId: 'surrogate-decision-maker',
      text: 'Surrogate Decision Maker',
      type: 'text',
    },
    {
      linkId: 'cor',
      text: 'Code Order and Resuscitation',
      type: 'text',
    },
    {
      linkId: 'advanced-directives',
      text: 'Advanced Directives/POLSTs',
      type: 'text',
    },
    {
      linkId: 'mdpoa',
      text: 'MDPOA',
      type: 'text',
    },
  ] as const,
} satisfies Questionnaire
